import {
  BILL_TYPES,
  BILL_TYPE_META,
  AUTO_FILL_TYPES,
} from "../../../constants/billTypes";

export { AUTO_FILL_TYPES };

// All bill-type cards the upload screen knows how to render. Which of these
// are actually shown to the landlord for a given flat/cycle is decided by
// billVisibility.js — this is just the master list.
export const BILL_CARDS = [
  BILL_TYPE_META[BILL_TYPES.RENT],
  BILL_TYPE_META[BILL_TYPES.ELECTRICITY],
  BILL_TYPE_META[BILL_TYPES.GAS],
  BILL_TYPE_META[BILL_TYPES.WATER],
  BILL_TYPE_META[BILL_TYPES.MAINTENANCE],
  BILL_TYPE_META[BILL_TYPES.SECURITY],
  BILL_TYPE_META[BILL_TYPES.TRASH],
];
